import { RIODateTime } from '#lib/RIODateTime.ts';

const DATE_PATTERN = /^(\d{1,2})[/.](\d{1,2})[/.](\d{2}|\d{4})$/;
const TIME_PATTERN = /^(\d{1,2}):(\d{1,2})$/;

const parseDateParts = (rawDate: string): { day: number; month: number; year: number } | undefined => {
    const match = rawDate.trim().match(DATE_PATTERN);
    if (!match) {
        return undefined;
    }

    const day = Number(match[1]);
    const month = Number(match[2]);
    const yearRaw = Number(match[3]);
    const year = match[3].length === 2 ? 2000 + yearRaw : yearRaw;

    if (month < 1 || month > 12 || day < 1 || day > 31) {
        return undefined;
    }

    return { day, month, year };
};

const parseTimeParts = (rawTime?: string): { hours: number; minutes: number } => {
    if (!rawTime) {
        return { hours: 0, minutes: 0 };
    }

    const match = rawTime.trim().match(TIME_PATTERN);
    if (!match) {
        return { hours: 0, minutes: 0 };
    }

    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
        return { hours: 0, minutes: 0 };
    }

    return { hours, minutes };
};

export const parseDate = ({ date, time }: { date: string | undefined; time?: string }): string | undefined => {
    if (date === undefined) {
        return undefined;
    }

    const dateParts = parseDateParts(date);
    if (!dateParts) {
        return undefined;
    }

    const timeParts = parseTimeParts(time);
    const localDate = RIODateTime.TryFromLocalParts({
        year: dateParts.year,
        month: dateParts.month,
        day: dateParts.day,
        hour: timeParts.hours,
        minute: timeParts.minutes,
    });

    if (!localDate) {
        return undefined;
    }

    return localDate.toISOString({ suppressMilliseconds: true }) ?? undefined;
};
